/**
 * MenuUnavailablePage -- shown when a menu slug resolves but the menu is
 * schedule-inactive (meta.schedule_status === 'unavailable').
 */

import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui'
import { formatNextAvailable } from '../utils/scheduleFormat'

interface MenuUnavailablePageProps {
  slug: string
  nextAvailableAt?: string | null
  businessTimeZone?: string | null
}

export function MenuUnavailablePage({
  slug,
  nextAvailableAt,
  businessTimeZone,
}: MenuUnavailablePageProps) {
  const { t } = useTranslation()
  const safeNextAvailableAt = nextAvailableAt?.trim() ? nextAvailableAt : null

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="text-center space-y-4 max-w-sm">
        <div className="text-5xl" aria-hidden="true">&#128336;</div>
        <h1 className="text-2xl font-bold text-foreground">{t('common:notAvailableRightNow')}</h1>
        <p className="text-muted-foreground text-sm">
          {t('common:menuNotAvailable', { slug })}
        </p>
        {safeNextAvailableAt && (
          <p className="text-sm text-foreground font-medium">
            {t('common:nextAvailable', { time: formatNextAvailable(safeNextAvailableAt, businessTimeZone) })}
          </p>
        )}
        <Button
          variant="link"
          className="min-h-[44px]"
          onClick={() => {
            window.history.pushState({}, '', '/')
            window.dispatchEvent(new PopStateEvent('popstate'))
          }}
        >
          {t('common:viewAllMenus')}
        </Button>
      </div>
    </div>
  )
}
